<!-- eslint-disable vue/html-self-closing -->
<template>
  <div>
    <button
      id="print-btn"
      class="btn btn-success"
      @click="handlePrint"
    >
      Print
    </button>
    <router-link
      :to="`/customers/${customerId}`"
      class="btn btn-primary mx-2"
    >
      Go To Customer Details
    </router-link>
    <div
      v-if="Object.keys(subscription).length > 0"
      id="subscription-invoice-POS"
    >

      <center id="top">
        <div class="logo">
          <img
            :src="require('@/assets/images/logo/logo.svg')"
            width="80"
            height="80"
          >
        </div>
        <div class="info">
          <h1>Wash Capital Laundry</h1>
          <h5 class="font-size">
            <span>Mobile: +96594194196</span>
          </h5>
          <h5 class="font-size">
            <span>Subscription Receipt إيصال الاشتراك</span>
          </h5>
        </div><!--End Info-->
      </center><!--End InvoiceTop-->
      <div id="mid-1">
        <div class="info">
          <!-- <h2>Contact Info</h2> -->
          <p class="info-container font-size">
            <span>
              <strong>رقم الاشتراك</strong>
              <br>
              <strong>Subscription ID</strong>
              <br>
              {{ subscription.id }}
            </span>
            <span>
              <strong>رقم معاملة الدفع</strong>
              <br>
              <strong>Transaction ID</strong>
              <br>
              #{{ subscription.transaction.id }}
            </span>
            <span v-if="subscription.transaction.paid_date">
              <strong>تاريخ الدفع</strong>
              <br>
              <strong>Payment Date</strong>
              <br>
              {{ subscription.transaction.paid_date }}
            </span>
          </p>
        </div>
      </div><!--End Invoice Mid-->
      <div id="mid">
        <div class="info">
          <h2 class="font-size">
            <span><strong>Contact Info بيانات التواصل</strong></span>
          </h2>
          <p class="info-container font-size no-spaces">
            <span v-if="subscription.user.full_name">
              <strong>Name الاسم</strong>
              <br>
              {{ subscription.user.full_name }}
            </span>
            <!--            <span v-if="subscription.user.email">-->
            <!--              <strong>Email البريد الإلكتروني</strong>-->
            <!--              <br>-->
            <!--              {{ subscription.user.email }}-->
            <!--            </span>-->
            <span
              v-if="subscription.user.phone"
              class="phone-box"
            >
              <strong>Phone الهاتف</strong>
              <br>
              {{ subscription.user.phone }}
            </span>
          </p>
          <p class="font-size">
            <span v-if="fullAddress">
              <strong>Address العنوان</strong>
              <br>
              {{ fullAddress }}
            </span>
          </p>
        </div>
      </div><!--End Invoice Mid-->
      <div
        v-if="user.subscriptions_balance || user.wallet_amount"
        id="mid-1"
      >
        <div class="info">
          <!-- <h2>Info</h2> -->
          <p class="info-container font-size no-spaces">
            <span v-if="user.subscriptions_balance">
              <strong>Subscriptions Balance رصيد الاشتراكات</strong>
              <br>
              {{ user.subscriptions_balance }} KD
            </span>
            <span v-if="user.wallet_amount">
              <strong>Wallet Amount رصيد المحفظة</strong>
              <br>
              {{ user.wallet_amount }} KD
            </span>
          </p>
        </div>
      </div>
      <!--End Invoice Mid-->
      <div id="bot">

        <div
          v-if="Object.keys(subscription).length > 0"
          id="table"
        >
          <table>
            <tr class="tabletitle table-header">
              <td
                class="item"
                colspan="2"
              >
                <h2 class="font-size">
                  <span>الاشتراك</span>
                  <br>
                  <span>Subscription</span>
                  <br>
                </h2>
              </td>
              <td class="Rate">
                <h2 class="font-size">
                  <span>الرصيد</span>
                  <br>
                  <span>Balance</span>
                  <br>
                </h2>
              </td>
              <td class="Rate">
                <h2 class="font-size text-center">
                  <span>السعر</span>
                  <br>
                  <span>Price</span>
                  <br>
                </h2>
              </td>
            </tr>
            <tbody>
              <tr>
                <td
                  class="tableitem"
                  colspan="2"
                >
                  <span class="itemtext font-size">
                    {{ subscription.subscription.name }}
                  </span>
                </td>
                <td class="tableitem text-center">
                  <span class="itemtext font-size">
                    {{ subscription.subscription.balance }}
                  </span>
                </td>
                <td class="tableitem text-center">
                  <span class="itemtext font-size">
                    {{ subscription.subscription.price }}
                  </span>
                </td>
              </tr>
              <!-- payment details -->
              <tr
                v-if="subscription.payment_method"
                class="tabletitle no-spaces"
              >
                <td class="Rate no-spaces">
                  <h2 class="font-size no-spaces">
                    <span>Payment Method طريقة الدفع</span>
                  </h2>
                </td>
                <td></td>
                <td></td>
                <td
                  class="payment no-spaces"
                  colspan="2"
                >
                  <h2 class="font-size no-spaces">
                    {{ subscription.payment_method.name }}
                  </h2>
                </td>
              </tr>
            </tbody>
          </table>
        </div><!--End Table-->

      </div><!--End InvoiceBot-->
      <div
        id="legalcopy"
        class="font-size text-center"
      >
        <span class="font-size">
          شكراً لك
        </span>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 1024 1024"><defs><clipPath id="clip-path-dot-color"><rect x="62" y="341" width="31" height="31" transform="rotate(0,77.5,356.5)"/><rect x="62" y="372" width="31" height="31" transform="rotate(0,77.5,387.5)"/><rect x="62" y="403" width="31" height="31" transform="rotate(0,77.5,418.5)"/><rect x="62" y="465" width="31" height="31" transform="rotate(0,77.5,480.5)"/><rect x="62" y="496" width="31" height="31" transform="rotate(0,77.5,511.5)"/><rect x="62" y="527" width="31" height="31" transform="rotate(0,77.5,542.5)"/><rect x="62" y="620" width="31" height="31" transform="rotate(0,77.5,635.5)"/><rect x="62" y="651" width="31" height="31" transform="rotate(0,77.5,666.5)"/><rect x="93" y="403" width="31" height="31" transform="rotate(0,108.5,418.5)"/><rect x="93" y="465" width="31" height="31" transform="rotate(0,108.5,480.5)"/><rect x="93" y="558" width="31" height="31" transform="rotate(0,108.5,573.5)"/><rect x="93" y="589" width="31" height="31" transform="rotate(0,108.5,604.5)"/><rect x="93" y="682" width="31" height="31" transform="rotate(0,108.5,697.5)"/><rect x="124" y="310" width="31" height="31" transform="rotate(0,139.5,325.5)"/><rect x="124" y="403" width="31" height="31" transform="rotate(0,139.5,418.5)"/><rect x="124" y="434" width="31" height="31" transform="rotate(0,139.5,449.5)"/><rect x="124" y="465" width="31" height="31" transform="rotate(0,139.5,480.5)"/><rect x="124" y="496" width="31" height="31" transform="rotate(0,139.5,511.5)"/><rect x="124" y="558" width="31" height="31" transform="rotate(0,139.5,573.5)"/><rect x="124" y="589" width="31" height="31" transform="rotate(0,139.5,604.5)"/><rect x="124" y="651" width="31" height="31" transform="rotate(0,139.5,666.5)"/><rect x="124" y="682" width="31" height="31" transform="rotate(0,139.5,697.5)"/><rect x="155" y="403" width="31" height="31" transform="rotate(0,170.5,418.5)"/><rect x="155" y="434" width="31" height="31" transform="rotate(0,170.5,449.5)"/><rect x="155" y="496" width="31" height="31" transform="rotate(0,170.5,511.5)"/><rect x="155" y="527" width="31" height="31" transform="rotate(0,170.5,542.5)"/><rect x="155" y="558" width="31" height="31" transform="rotate(0,170.5,573.5)"/><rect x="155" y="620" width="31" height="31" transform="rotate(0,170.5,635.5)"/><rect x="155" y="651" width="31" height="31" transform="rotate(0,170.5,666.5)"/><rect x="186" y="310" width="31" height="31" transform="rotate(0,201.5,325.5)"/><rect x="186" y="341" width="31" height="31" transform="rotate(0,201.5,356.5)"/><rect x="186" y="372" width="31" height="31" transform="rotate(0,201.5,387.5)"/><rect x="186" y="403" width="31" height="31" transform="rotate(0,201.5,418.5)"/><rect x="186" y="496" width="31" height="31" transform="rotate(0,201.5,511.5)"/><rect x="217" y="310" width="31" height="31" transform="rotate(0,232.5,325.5)"/><rect x="217" y="341" width="31" height="31" transform="rotate(0,232.5,356.5)"/><rect x="217" y="403" width="31" height="31" transform="rotate(0,232.5,418.5)"/><rect x="217" y="434" width="31" height="31" transform="rotate(0,232.5,449.5)"/><rect x="217" y="496" width="31" height="31" transform="rotate(0,232.5,511.5)"/><rect x="217" y="620" width="31" height="31" transform="rotate(0,232.5,635.5)"/><rect x="217" y="651" width="31" height="31" transform="rotate(0,232.5,666.5)"/><rect x="217" y="682" width="31" height="31" transform="rotate(0,232.5,697.5)"/><rect x="248" y="310" width="31" height="31" transform="rotate(0,263.5,325.5)"/><rect x="248" y="372" width="31" height="31" transform="rotate(0,263.5,387.5)"/><rect x="248" y="434" width="31" height="31" transform="rotate(0,263.5,449.5)"/><rect x="248" y="496" width="31" height="31" transform="rotate(0,263.5,511.5)"/><rect x="248" y="558" width="31" height="31" transform="rotate(0,263.5,573.5)"/><rect x="248" y="620" width="31" height="31" transform="rotate(0,263.5,635.5)"/><rect x="248" y="682" width="31" height="31" transform="rotate(0,263.5,697.5)"/><rect x="279" y="372" width="31" height="31" transform="rotate(0,294.5,387.5)"/><rect x="279" y="403" width="31" height="31" transform="rotate(0,294.5,418.5)"/><rect x="279" y="589" width="31" height="31" transform="rotate(0,294.5,604.5)"/><rect x="279" y="620" width="31" height="31" transform="rotate(0,294.5,635.5)"/><rect x="279" y="651" width="31" height="31" transform="rotate(0,294.5,666.5)"/><rect x="310" y="93" width="31" height="31" transform="rotate(0,325.5,108.5)"/><rect x="310" y="186" width="31" height="31" transform="rotate(0,325.5,201.5)"/><rect x="310" y="248" width="31" height="31" transform="rotate(0,325.5,263.5)"/><rect x="310" y="310" width="31" height="31" transform="rotate(0,325.5,325.5)"/><rect x="310" y="341" width="31" height="31" transform="rotate(0,325.5,356.5)"/><rect x="310" y="372" width="31" height="31" transform="rotate(0,325.5,387.5)"/><rect x="310" y="403" width="31" height="31" transform="rotate(0,325.5,418.5)"/><rect x="310" y="465" width="31" height="31" transform="rotate(0,325.5,480.5)"/><rect x="310" y="527" width="31" height="31" transform="rotate(0,325.5,542.5)"/><rect x="310" y="558" width="31" height="31" transform="rotate(0,325.5,573.5)"/><rect x="310" y="620" width="31" height="31" transform="rotate(0,325.5,635.5)"/><rect x="310" y="651" width="31" height="31" transform="rotate(0,325.5,666.5)"/><rect x="310" y="682" width="31" height="31" transform="rotate(0,325.5,697.5)"/><rect x="310" y="713" width="31" height="31" transform="rotate(0,325.5,728.5)"/><rect x="310" y="775" width="31" height="31" transform="rotate(0,325.5,790.5)"/><rect x="310" y="806" width="31" height="31" transform="rotate(0,325.5,821.5)"/><rect x="310" y="868" width="31" height="31" transform="rotate(0,325.5,883.5)"/><rect x="341" y="124" width="31" height="31" transform="rotate(0,356.5,139.5)"/><rect x="341" y="155" width="31" height="31" transform="rotate(0,356.5,170.5)"/><rect x="341" y="186" width="31" height="31" transform="rotate(0,356.5,201.5)"/><rect x="341" y="279" width="31" height="31" transform="rotate(0,356.5,294.5)"/><rect x="341" y="341" width="31" height="31" transform="rotate(0,356.5,356.5)"/><rect x="341" y="434" width="31" height="31" transform="rotate(0,356.5,449.5)"/><rect x="341" y="496" width="31" height="31" transform="rotate(0,356.5,511.5)"/><rect x="341" y="527" width="31" height="31" transform="rotate(0,356.5,542.5)"/><rect x="341" y="558" width="31" height="31" transform="rotate(0,356.5,573.5)"/><rect x="341" y="589" width="31" height="31" transform="rotate(0,356.5,604.5)"/><rect x="341" y="651" width="31" height="31" transform="rotate(0,356.5,666.5)"/><rect x="341" y="682" width="31" height="31" transform="rotate(0,356.5,697.5)"/><rect x="341" y="744" width="31" height="31" transform="rotate(0,356.5,759.5)"/><rect x="341" y="775" width="31" height="31" transform="rotate(0,356.5,790.5)"/><rect x="341" y="806" width="31" height="31" transform="rotate(0,356.5,821.5)"/><rect x="341" y="837" width="31" height="31" transform="rotate(0,356.5,852.5)"/><rect x="341" y="868" width="31" height="31" transform="rotate(0,356.5,883.5)"/><rect x="341" y="899" width="31" height="31" transform="rotate(0,356.5,914.5)"/><rect x="341" y="930" width="31" height="31" transform="rotate(0,356.5,945.5)"/><rect x="372" y="62" width="31" height="31" transform="rotate(0,387.5,77.5)"/><rect x="372" y="124" width="31" height="31" transform="rotate(0,387.5,139.5)"/><rect x="372" y="155" width="31" height="31" transform="rotate(0,387.5,170.5)"/><rect x="372" y="248" width="31" height="31" transform="rotate(0,387.5,263.5)"/><rect x="372" y="310" width="31" height="31" transform="rotate(0,387.5,325.5)"/><rect x="372" y="434" width="31" height="31" transform="rotate(0,387.5,449.5)"/><rect x="372" y="465" width="31" height="31" transform="rotate(0,387.5,480.5)"/><rect x="372" y="496" width="31" height="31" transform="rotate(0,387.5,511.5)"/><rect x="372" y="527" width="31" height="31" transform="rotate(0,387.5,542.5)"/><rect x="372" y="589" width="31" height="31" transform="rotate(0,387.5,604.5)"/><rect x="372" y="713" width="31" height="31" transform="rotate(0,387.5,728.5)"/><rect x="372" y="806" width="31" height="31" transform="rotate(0,387.5,821.5)"/><rect x="372" y="930" width="31" height="31" transform="rotate(0,387.5,945.5)"/><rect x="403" y="62" width="31" height="31" transform="rotate(0,418.5,77.5)"/><rect x="403" y="93" width="31" height="31" transform="rotate(0,418.5,108.5)"/><rect x="403" y="341" width="31" height="31" transform="rotate(0,418.5,356.5)"/><rect x="403" y="372" width="31" height="31" transform="rotate(0,418.5,387.5)"/><rect x="403" y="465" width="31" height="31" transform="rotate(0,418.5,480.5)"/><rect x="403" y="527" width="31" height="31" transform="rotate(0,418.5,542.5)"/><rect x="403" y="589" width="31" height="31" transform="rotate(0,418.5,604.5)"/><rect x="403" y="620" width="31" height="31" transform="rotate(0,418.5,635.5)"/><rect x="403" y="651" width="31" height="31" transform="rotate(0,418.5,666.5)"/><rect x="403" y="682" width="31" height="31" transform="rotate(0,418.5,697.5)"/><rect x="403" y="713" width="31" height="31" transform="rotate(0,418.5,728.5)"/><rect x="403" y="775" width="31" height="31" transform="rotate(0,418.5,790.5)"/><rect x="403" y="806" width="31" height="31" transform="rotate(0,418.5,821.5)"/><rect x="403" y="837" width="31" height="31" transform="rotate(0,418.5,852.5)"/><rect x="403" y="899" width="31" height="31" transform="rotate(0,418.5,914.5)"/><rect x="403" y="930" width="31" height="31" transform="rotate(0,418.5,945.5)"/><rect x="434" y="93" width="31" height="31" transform="rotate(0,449.5,108.5)"/><rect x="434" y="124" width="31" height="31" transform="rotate(0,449.5,139.5)"/><rect x="434" y="186" width="31" height="31" transform="rotate(0,449.5,201.5)"/><rect x="434" y="248" width="31" height="31" transform="rotate(0,449.5,263.5)"/><rect x="434" y="279" width="31" height="31" transform="rotate(0,449.5,294.5)"/><rect x="434" y="310" width="31" height="31" transform="rotate(0,449.5,325.5)"/><rect x="434" y="403" width="31" height="31" transform="rotate(0,449.5,418.5)"/><rect x="434" y="465" width="31" height="31" transform="rotate(0,449.5,480.5)"/><rect x="434" y="527" width="31" height="31" transform="rotate(0,449.5,542.5)"/><rect x="434" y="558" width="31" height="31" transform="rotate(0,449.5,573.5)"/><rect x="434" y="589" width="31" height="31" transform="rotate(0,449.5,604.5)"/><rect x="434" y="620" width="31" height="31" transform="rotate(0,449.5,635.5)"/><rect x="434" y="651" width="31" height="31" transform="rotate(0,449.5,666.5)"/><rect x="434" y="775" width="31" height="31" transform="rotate(0,449.5,790.5)"/><rect x="434" y="837" width="31" height="31" transform="rotate(0,449.5,852.5)"/><rect x="434" y="868" width="31" height="31" transform="rotate(0,449.5,883.5)"/><rect x="434" y="930" width="31" height="31" transform="rotate(0,449.5,945.5)"/><rect x="465" y="124" width="31" height="31" transform="rotate(0,480.5,139.5)"/><rect x="465" y="186" width="31" height="31" transform="rotate(0,480.5,201.5)"/><rect x="465" y="217" width="31" height="31" transform="rotate(0,480.5,232.5)"/><rect x="465" y="279" width="31" height="31" transform="rotate(0,480.5,294.5)"/><rect x="465" y="310" width="31" height="31" transform="rotate(0,480.5,325.5)"/><rect x="465" y="403" width="31" height="31" transform="rotate(0,480.5,418.5)"/><rect x="465" y="465" width="31" height="31" transform="rotate(0,480.5,480.5)"/><rect x="465" y="527" width="31" height="31" transform="rotate(0,480.5,542.5)"/><rect x="465" y="589" width="31" height="31" transform="rotate(0,480.5,604.5)"/><rect x="465" y="620" width="31" height="31" transform="rotate(0,480.5,635.5)"/><rect x="465" y="744" width="31" height="31" transform="rotate(0,480.5,759.5)"/><rect x="465" y="806" width="31" height="31" transform="rotate(0,480.5,821.5)"/><rect x="465" y="868" width="31" height="31" transform="rotate(0,480.5,883.5)"/><rect x="465" y="899" width="31" height="31" transform="rotate(0,480.5,914.5)"/><rect x="465" y="930" width="31" height="31" transform="rotate(0,480.5,945.5)"/><rect x="496" y="93" width="31" height="31" transform="rotate(0,511.5,108.5)"/><rect x="496" y="155" width="31" height="31" transform="rotate(0,511.5,170.5)"/><rect x="496" y="186" width="31" height="31" transform="rotate(0,511.5,201.5)"/><rect x="496" y="248" width="31" height="31" transform="rotate(0,511.5,263.5)"/><rect x="496" y="279" width="31" height="31" transform="rotate(0,511.5,294.5)"/><rect x="496" y="372" width="31" height="31" transform="rotate(0,511.5,387.5)"/><rect x="496" y="403" width="31" height="31" transform="rotate(0,511.5,418.5)"/><rect x="496" y="496" width="31" height="31" transform="rotate(0,511.5,511.5)"/><rect x="496" y="558" width="31" height="31" transform="rotate(0,511.5,573.5)"/><rect x="496" y="620" width="31" height="31" transform="rotate(0,511.5,635.5)"/><rect x="496" y="682" width="31" height="31" transform="rotate(0,511.5,697.5)"/><rect x="496" y="713" width="31" height="31" transform="rotate(0,511.5,728.5)"/><rect x="496" y="806" width="31" height="31" transform="rotate(0,511.5,821.5)"/><rect x="496" y="899" width="31" height="31" transform="rotate(0,511.5,914.5)"/><rect x="496" y="930" width="31" height="31" transform="rotate(0,511.5,945.5)"/><rect x="527" y="62" width="31" height="31" transform="rotate(0,542.5,77.5)"/><rect x="527" y="93" width="31" height="31" transform="rotate(0,542.5,108.5)"/><rect x="527" y="279" width="31" height="31" transform="rotate(0,542.5,294.5)"/><rect x="527" y="403" width="31" height="31" transform="rotate(0,542.5,418.5)"/><rect x="527" y="434" width="31" height="31" transform="rotate(0,542.5,449.5)"/><rect x="527" y="744" width="31" height="31" transform="rotate(0,542.5,759.5)"/><rect x="527" y="775" width="31" height="31" transform="rotate(0,542.5,790.5)"/><rect x="527" y="837" width="31" height="31" transform="rotate(0,542.5,852.5)"/><rect x="527" y="930" width="31" height="31" transform="rotate(0,542.5,945.5)"/><rect x="558" y="124" width="31" height="31" transform="rotate(0,573.5,139.5)"/><rect x="558" y="248" width="31" height="31" transform="rotate(0,573.5,263.5)"/><rect x="558" y="279" width="31" height="31" transform="rotate(0,573.5,294.5)"/><rect x="558" y="372" width="31" height="31" transform="rotate(0,573.5,387.5)"/><rect x="558" y="403" width="31" height="31" transform="rotate(0,573.5,418.5)"/><rect x="558" y="434" width="31" height="31" transform="rotate(0,573.5,449.5)"/><rect x="558" y="465" width="31" height="31" transform="rotate(0,573.5,480.5)"/><rect x="558" y="496" width="31" height="31" transform="rotate(0,573.5,511.5)"/><rect x="558" y="558" width="31" height="31" transform="rotate(0,573.5,573.5)"/><rect x="558" y="651" width="31" height="31" transform="rotate(0,573.5,666.5)"/><rect x="558" y="713" width="31" height="31" transform="rotate(0,573.5,728.5)"/><rect x="558" y="899" width="31" height="31" transform="rotate(0,573.5,914.5)"/><rect x="589" y="62" width="31" height="31" transform="rotate(0,604.5,77.5)"/><rect x="589" y="93" width="31" height="31" transform="rotate(0,604.5,108.5)"/><rect x="589" y="155" width="31" height="31" transform="rotate(0,604.5,170.5)"/><rect x="589" y="310" width="31" height="31" transform="rotate(0,604.5,325.5)"/><rect x="589" y="372" width="31" height="31" transform="rotate(0,604.5,387.5)"/><rect x="589" y="589" width="31" height="31" transform="rotate(0,604.5,604.5)"/><rect x="589" y="620" width="31" height="31" transform="rotate(0,604.5,635.5)"/><rect x="589" y="713" width="31" height="31" transform="rotate(0,604.5,728.5)"/><rect x="589" y="775" width="31" height="31" transform="rotate(0,604.5,790.5)"/><rect x="589" y="806" width="31" height="31" transform="rotate(0,604.5,821.5)"/><rect x="589" y="837" width="31" height="31" transform="rotate(0,604.5,852.5)"/><rect x="589" y="930" width="31" height="31" transform="rotate(0,604.5,945.5)"/><rect x="620" y="124" width="31" height="31" transform="rotate(0,635.5,139.5)"/><rect x="620" y="155" width="31" height="31" transform="rotate(0,635.5,170.5)"/><rect x="620" y="186" width="31" height="31" transform="rotate(0,635.5,201.5)"/><rect x="620" y="217" width="31" height="31" transform="rotate(0,635.5,232.5)"/><rect x="620" y="248" width="31" height="31" transform="rotate(0,635.5,263.5)"/><rect x="620" y="279" width="31" height="31" transform="rotate(0,635.5,294.5)"/><rect x="620" y="310" width="31" height="31" transform="rotate(0,635.5,325.5)"/><rect x="620" y="341" width="31" height="31" transform="rotate(0,635.5,356.5)"/><rect x="620" y="403" width="31" height="31" transform="rotate(0,635.5,418.5)"/><rect x="620" y="434" width="31" height="31" transform="rotate(0,635.5,449.5)"/><rect x="620" y="465" width="31" height="31" transform="rotate(0,635.5,480.5)"/><rect x="620" y="496" width="31" height="31" transform="rotate(0,635.5,511.5)"/><rect x="620" y="527" width="31" height="31" transform="rotate(0,635.5,542.5)"/><rect x="620" y="620" width="31" height="31" transform="rotate(0,635.5,635.5)"/><rect x="620" y="775" width="31" height="31" transform="rotate(0,635.5,790.5)"/><rect x="620" y="806" width="31" height="31" transform="rotate(0,635.5,821.5)"/><rect x="620" y="930" width="31" height="31" transform="rotate(0,635.5,945.5)"/><rect x="651" y="124" width="31" height="31" transform="rotate(0,666.5,139.5)"/><rect x="651" y="186" width="31" height="31" transform="rotate(0,666.5,201.5)"/><rect x="651" y="279" width="31" height="31" transform="rotate(0,666.5,294.5)"/><rect x="651" y="310" width="31" height="31" transform="rotate(0,666.5,325.5)"/><rect x="651" y="372" width="31" height="31" transform="rotate(0,666.5,387.5)"/><rect x="651" y="465" width="31" height="31" transform="rotate(0,666.5,480.5)"/><rect x="651" y="496" width="31" height="31" transform="rotate(0,666.5,511.5)"/><rect x="651" y="527" width="31" height="31" transform="rotate(0,666.5,542.5)"/><rect x="651" y="558" width="31" height="31" transform="rotate(0,666.5,573.5)"/><rect x="651" y="589" width="31" height="31" transform="rotate(0,666.5,604.5)"/><rect x="651" y="651" width="31" height="31" transform="rotate(0,666.5,666.5)"/><rect x="651" y="899" width="31" height="31" transform="rotate(0,666.5,914.5)"/><rect x="682" y="62" width="31" height="31" transform="rotate(0,697.5,77.5)"/><rect x="682" y="93" width="31" height="31" transform="rotate(0,697.5,108.5)"/><rect x="682" y="186" width="31" height="31" transform="rotate(0,697.5,201.5)"/><rect x="682" y="248" width="31" height="31" transform="rotate(0,697.5,263.5)"/><rect x="682" y="310" width="31" height="31" transform="rotate(0,697.5,325.5)"/><rect x="682" y="434" width="31" height="31" transform="rotate(0,697.5,449.5)"/><rect x="682" y="465" width="31" height="31" transform="rotate(0,697.5,480.5)"/><rect x="682" y="589" width="31" height="31" transform="rotate(0,697.5,604.5)"/><rect x="682" y="651" width="31" height="31" transform="rotate(0,697.5,666.5)"/><rect x="682" y="682" width="31" height="31" transform="rotate(0,697.5,697.5)"/><rect x="682" y="713" width="31" height="31" transform="rotate(0,697.5,728.5)"/><rect x="682" y="744" width="31" height="31" transform="rotate(0,697.5,759.5)"/><rect x="682" y="775" width="31" height="31" transform="rotate(0,697.5,790.5)"/><rect x="682" y="806" width="31" height="31" transform="rotate(0,697.5,821.5)"/><rect x="682" y="930" width="31" height="31" transform="rotate(0,697.5,945.5)"/><rect x="713" y="310" width="31" height="31" transform="rotate(0,728.5,325.5)"/><rect x="713" y="403" width="31" height="31" transform="rotate(0,728.5,418.5)"/><rect x="713" y="527" width="31" height="31" transform="rotate(0,728.5,542.5)"/><rect x="713" y="620" width="31" height="31" transform="rotate(0,728.5,635.5)"/><rect x="713" y="682" width="31" height="31" transform="rotate(0,728.5,697.5)"/><rect x="713" y="806" width="31" height="31" transform="rotate(0,728.5,821.5)"/><rect x="713" y="868" width="31" height="31" transform="rotate(0,728.5,883.5)"/><rect x="713" y="899" width="31" height="31" transform="rotate(0,728.5,914.5)"/><rect x="744" y="341" width="31" height="31" transform="rotate(0,759.5,356.5)"/><rect x="744" y="372" width="31" height="31" transform="rotate(0,759.5,387.5)"/><rect x="744" y="403" width="31" height="31" transform="rotate(0,759.5,418.5)"/><rect x="744" y="434" width="31" height="31" transform="rotate(0,759.5,449.5)"/><rect x="744" y="465" width="31" height="31" transform="rotate(0,759.5,480.5)"/><rect x="744" y="527" width="31" height="31" transform="rotate(0,759.5,542.5)"/><rect x="744" y="589" width="31" height="31" transform="rotate(0,759.5,604.5)"/><rect x="744" y="651" width="31" height="31" transform="rotate(0,759.5,666.5)"/><rect x="744" y="682" width="31" height="31" transform="rotate(0,759.5,697.5)"/><rect x="744" y="744" width="31" height="31" transform="rotate(0,759.5,759.5)"/><rect x="744" y="806" width="31" height="31" transform="rotate(0,759.5,821.5)"/><rect x="744" y="930" width="31" height="31" transform="rotate(0,759.5,945.5)"/><rect x="775" y="496" width="31" height="31" transform="rotate(0,790.5,511.5)"/><rect x="775" y="589" width="31" height="31" transform="rotate(0,790.5,604.5)"/><rect x="775" y="620" width="31" height="31" transform="rotate(0,790.5,635.5)"/><rect x="775" y="651" width="31" height="31" transform="rotate(0,790.5,666.5)"/><rect x="775" y="682" width="31" height="31" transform="rotate(0,790.5,697.5)"/><rect x="775" y="806" width="31" height="31" transform="rotate(0,790.5,821.5)"/><rect x="775" y="837" width="31" height="31" transform="rotate(0,790.5,852.5)"/><rect x="806" y="310" width="31" height="31" transform="rotate(0,821.5,325.5)"/><rect x="806" y="341" width="31" height="31" transform="rotate(0,821.5,356.5)"/><rect x="806" y="372" width="31" height="31" transform="rotate(0,821.5,387.5)"/><rect x="806" y="403" width="31" height="31" transform="rotate(0,821.5,418.5)"/><rect x="806" y="434" width="31" height="31" transform="rotate(0,821.5,449.5)"/><rect x="806" y="527" width="31" height="31" transform="rotate(0,821.5,542.5)"/><rect x="806" y="620" width="31" height="31" transform="rotate(0,821.5,635.5)"/><rect x="806" y="651" width="31" height="31" transform="rotate(0,821.5,666.5)"/><rect x="806" y="682" width="31" height="31" transform="rotate(0,821.5,697.5)"/><rect x="806" y="713" width="31" height="31" transform="rotate(0,821.5,728.5)"/><rect x="806" y="744" width="31" height="31" transform="rotate(0,821.5,759.5)"/><rect x="806" y="775" width="31" height="31" transform="rotate(0,821.5,790.5)"/><rect x="806" y="806" width="31" height="31" transform="rotate(0,821.5,821.5)"/><rect x="806" y="899" width="31" height="31" transform="rotate(0,821.5,914.5)"/><rect x="806" y="930" width="31" height="31" transform="rotate(0,821.5,945.5)"/><rect x="837" y="403" width="31" height="31" transform="rotate(0,852.5,418.5)"/><rect x="837" y="496" width="31" height="31" transform="rotate(0,852.5,511.5)"/><rect x="837" y="558" width="31" height="31" transform="rotate(0,852.5,573.5)"/><rect x="837" y="589" width="31" height="31" transform="rotate(0,852.5,604.5)"/><rect x="837" y="775" width="31" height="31" transform="rotate(0,852.5,790.5)"/><rect x="837" y="837" width="31" height="31" transform="rotate(0,852.5,852.5)"/><rect x="837" y="868" width="31" height="31" transform="rotate(0,852.5,883.5)"/><rect x="837" y="899" width="31" height="31" transform="rotate(0,852.5,914.5)"/><rect x="868" y="434" width="31" height="31" transform="rotate(0,883.5,449.5)"/><rect x="868" y="465" width="31" height="31" transform="rotate(0,883.5,480.5)"/><rect x="868" y="496" width="31" height="31" transform="rotate(0,883.5,511.5)"/><rect x="868" y="558" width="31" height="31" transform="rotate(0,883.5,573.5)"/><rect x="868" y="589" width="31" height="31" transform="rotate(0,883.5,604.5)"/><rect x="868" y="651" width="31" height="31" transform="rotate(0,883.5,666.5)"/><rect x="868" y="682" width="31" height="31" transform="rotate(0,883.5,697.5)"/><rect x="868" y="713" width="31" height="31" transform="rotate(0,883.5,728.5)"/><rect x="868" y="868" width="31" height="31" transform="rotate(0,883.5,883.5)"/><rect x="868" y="899" width="31" height="31" transform="rotate(0,883.5,914.5)"/><rect x="868" y="930" width="31" height="31" transform="rotate(0,883.5,945.5)"/><rect x="899" y="310" width="31" height="31" transform="rotate(0,914.5,325.5)"/><rect x="899" y="341" width="31" height="31" transform="rotate(0,914.5,356.5)"/><rect x="899" y="434" width="31" height="31" transform="rotate(0,914.5,449.5)"/><rect x="899" y="496" width="31" height="31" transform="rotate(0,914.5,511.5)"/><rect x="899" y="589" width="31" height="31" transform="rotate(0,914.5,604.5)"/><rect x="899" y="620" width="31" height="31" transform="rotate(0,914.5,635.5)"/><rect x="899" y="682" width="31" height="31" transform="rotate(0,914.5,697.5)"/><rect x="899" y="713" width="31" height="31" transform="rotate(0,914.5,728.5)"/><rect x="899" y="744" width="31" height="31" transform="rotate(0,914.5,759.5)"/><rect x="899" y="775" width="31" height="31" transform="rotate(0,914.5,790.5)"/><rect x="899" y="837" width="31" height="31" transform="rotate(0,914.5,852.5)"/><rect x="899" y="899" width="31" height="31" transform="rotate(0,914.5,914.5)"/><rect x="899" y="930" width="31" height="31" transform="rotate(0,914.5,945.5)"/><rect x="930" y="341" width="31" height="31" transform="rotate(0,945.5,356.5)"/><rect x="930" y="496" width="31" height="31" transform="rotate(0,945.5,511.5)"/><rect x="930" y="527" width="31" height="31" transform="rotate(0,945.5,542.5)"/><rect x="930" y="589" width="31" height="31" transform="rotate(0,945.5,604.5)"/><rect x="930" y="682" width="31" height="31" transform="rotate(0,945.5,697.5)"/><rect x="930" y="744" width="31" height="31" transform="rotate(0,945.5,759.5)"/><rect x="930" y="806" width="31" height="31" transform="rotate(0,945.5,821.5)"/><rect x="930" y="868" width="31" height="31" transform="rotate(0,945.5,883.5)"/><rect x="930" y="899" width="31" height="31" transform="rotate(0,945.5,914.5)"/></clipPath><clipPath id="clip-path-corners-square-color-0-0"><rect x="62" y="62" width="31" height="31" transform="rotate(0,77.5,77.5)"/><rect x="62" y="93" width="31" height="31" transform="rotate(0,77.5,108.5)"/><rect x="62" y="124" width="31" height="31" transform="rotate(0,77.5,139.5)"/><rect x="62" y="155" width="31" height="31" transform="rotate(0,77.5,170.5)"/><rect x="62" y="186" width="31" height="31" transform="rotate(0,77.5,201.5)"/><rect x="62" y="217" width="31" height="31" transform="rotate(0,77.5,232.5)"/><rect x="62" y="248" width="31" height="31" transform="rotate(0,77.5,263.5)"/><rect x="93" y="62" width="31" height="31" transform="rotate(0,108.5,77.5)"/><rect x="93" y="248" width="31" height="31" transform="rotate(0,108.5,263.5)"/><rect x="124" y="62" width="31" height="31" transform="rotate(0,139.5,77.5)"/><rect x="124" y="248" width="31" height="31" transform="rotate(0,139.5,263.5)"/><rect x="155" y="62" width="31" height="31" transform="rotate(0,170.5,77.5)"/><rect x="155" y="248" width="31" height="31" transform="rotate(0,170.5,263.5)"/><rect x="186" y="62" width="31" height="31" transform="rotate(0,201.5,77.5)"/><rect x="186" y="248" width="31" height="31" transform="rotate(0,201.5,263.5)"/><rect x="217" y="62" width="31" height="31" transform="rotate(0,232.5,77.5)"/><rect x="217" y="248" width="31" height="31" transform="rotate(0,232.5,263.5)"/><rect x="248" y="62" width="31" height="31" transform="rotate(0,263.5,77.5)"/><rect x="248" y="93" width="31" height="31" transform="rotate(0,263.5,108.5)"/><rect x="248" y="124" width="31" height="31" transform="rotate(0,263.5,139.5)"/><rect x="248" y="155" width="31" height="31" transform="rotate(0,263.5,170.5)"/><rect x="248" y="186" width="31" height="31" transform="rotate(0,263.5,201.5)"/><rect x="248" y="217" width="31" height="31" transform="rotate(0,263.5,232.5)"/><rect x="248" y="248" width="31" height="31" transform="rotate(0,263.5,263.5)"/></clipPath><clipPath id="clip-path-corners-dot-color-0-0"><rect x="124" y="124" width="31" height="31" transform="rotate(0,139.5,139.5)"/><rect x="124" y="155" width="31" height="31" transform="rotate(0,139.5,170.5)"/><rect x="124" y="186" width="31" height="31" transform="rotate(0,139.5,201.5)"/><rect x="155" y="124" width="31" height="31" transform="rotate(0,170.5,139.5)"/><rect x="155" y="155" width="31" height="31" transform="rotate(0,170.5,170.5)"/><rect x="155" y="186" width="31" height="31" transform="rotate(0,170.5,201.5)"/><rect x="186" y="124" width="31" height="31" transform="rotate(0,201.5,139.5)"/><rect x="186" y="155" width="31" height="31" transform="rotate(0,201.5,170.5)"/><rect x="186" y="186" width="31" height="31" transform="rotate(0,201.5,201.5)"/></clipPath><clipPath id="clip-path-corners-square-color-1-0"><rect x="744" y="62" width="31" height="31" transform="rotate(0,759.5,77.5)"/><rect x="744" y="93" width="31" height="31" transform="rotate(0,759.5,108.5)"/><rect x="744" y="124" width="31" height="31" transform="rotate(0,759.5,139.5)"/><rect x="744" y="155" width="31" height="31" transform="rotate(0,759.5,170.5)"/><rect x="744" y="186" width="31" height="31" transform="rotate(0,759.5,201.5)"/><rect x="744" y="217" width="31" height="31" transform="rotate(0,759.5,232.5)"/><rect x="744" y="248" width="31" height="31" transform="rotate(0,759.5,263.5)"/><rect x="775" y="62" width="31" height="31" transform="rotate(0,790.5,77.5)"/><rect x="775" y="248" width="31" height="31" transform="rotate(0,790.5,263.5)"/><rect x="806" y="62" width="31" height="31" transform="rotate(0,821.5,77.5)"/><rect x="806" y="248" width="31" height="31" transform="rotate(0,821.5,263.5)"/><rect x="837" y="62" width="31" height="31" transform="rotate(0,852.5,77.5)"/><rect x="837" y="248" width="31" height="31" transform="rotate(0,852.5,263.5)"/><rect x="868" y="62" width="31" height="31" transform="rotate(0,883.5,77.5)"/><rect x="868" y="248" width="31" height="31" transform="rotate(0,883.5,263.5)"/><rect x="899" y="62" width="31" height="31" transform="rotate(0,914.5,77.5)"/><rect x="899" y="248" width="31" height="31" transform="rotate(0,914.5,263.5)"/><rect x="930" y="62" width="31" height="31" transform="rotate(0,945.5,77.5)"/><rect x="930" y="93" width="31" height="31" transform="rotate(0,945.5,108.5)"/><rect x="930" y="124" width="31" height="31" transform="rotate(0,945.5,139.5)"/><rect x="930" y="155" width="31" height="31" transform="rotate(0,945.5,170.5)"/><rect x="930" y="186" width="31" height="31" transform="rotate(0,945.5,201.5)"/><rect x="930" y="217" width="31" height="31" transform="rotate(0,945.5,232.5)"/><rect x="930" y="248" width="31" height="31" transform="rotate(0,945.5,263.5)"/></clipPath><clipPath id="clip-path-corners-dot-color-1-0"><rect x="806" y="124" width="31" height="31" transform="rotate(0,821.5,139.5)"/><rect x="806" y="155" width="31" height="31" transform="rotate(0,821.5,170.5)"/><rect x="806" y="186" width="31" height="31" transform="rotate(0,821.5,201.5)"/><rect x="837" y="124" width="31" height="31" transform="rotate(0,852.5,139.5)"/><rect x="837" y="155" width="31" height="31" transform="rotate(0,852.5,170.5)"/><rect x="837" y="186" width="31" height="31" transform="rotate(0,852.5,201.5)"/><rect x="868" y="124" width="31" height="31" transform="rotate(0,883.5,139.5)"/><rect x="868" y="155" width="31" height="31" transform="rotate(0,883.5,170.5)"/><rect x="868" y="186" width="31" height="31" transform="rotate(0,883.5,201.5)"/></clipPath><clipPath id="clip-path-corners-square-color-0-1"><rect x="62" y="744" width="31" height="31" transform="rotate(0,77.5,759.5)"/><rect x="62" y="775" width="31" height="31" transform="rotate(0,77.5,790.5)"/><rect x="62" y="806" width="31" height="31" transform="rotate(0,77.5,821.5)"/><rect x="62" y="837" width="31" height="31" transform="rotate(0,77.5,852.5)"/><rect x="62" y="868" width="31" height="31" transform="rotate(0,77.5,883.5)"/><rect x="62" y="899" width="31" height="31" transform="rotate(0,77.5,914.5)"/><rect x="62" y="930" width="31" height="31" transform="rotate(0,77.5,945.5)"/><rect x="93" y="744" width="31" height="31" transform="rotate(0,108.5,759.5)"/><rect x="93" y="930" width="31" height="31" transform="rotate(0,108.5,945.5)"/><rect x="124" y="744" width="31" height="31" transform="rotate(0,139.5,759.5)"/><rect x="124" y="930" width="31" height="31" transform="rotate(0,139.5,945.5)"/><rect x="155" y="744" width="31" height="31" transform="rotate(0,170.5,759.5)"/><rect x="155" y="930" width="31" height="31" transform="rotate(0,170.5,945.5)"/><rect x="186" y="744" width="31" height="31" transform="rotate(0,201.5,759.5)"/><rect x="186" y="930" width="31" height="31" transform="rotate(0,201.5,945.5)"/><rect x="217" y="744" width="31" height="31" transform="rotate(0,232.5,759.5)"/><rect x="217" y="930" width="31" height="31" transform="rotate(0,232.5,945.5)"/><rect x="248" y="744" width="31" height="31" transform="rotate(0,263.5,759.5)"/><rect x="248" y="775" width="31" height="31" transform="rotate(0,263.5,790.5)"/><rect x="248" y="806" width="31" height="31" transform="rotate(0,263.5,821.5)"/><rect x="248" y="837" width="31" height="31" transform="rotate(0,263.5,852.5)"/><rect x="248" y="868" width="31" height="31" transform="rotate(0,263.5,883.5)"/><rect x="248" y="899" width="31" height="31" transform="rotate(0,263.5,914.5)"/><rect x="248" y="930" width="31" height="31" transform="rotate(0,263.5,945.5)"/></clipPath><clipPath id="clip-path-corners-dot-color-0-1"><rect x="124" y="806" width="31" height="31" transform="rotate(0,139.5,821.5)"/><rect x="124" y="837" width="31" height="31" transform="rotate(0,139.5,852.5)"/><rect x="124" y="868" width="31" height="31" transform="rotate(0,139.5,883.5)"/><rect x="155" y="806" width="31" height="31" transform="rotate(0,170.5,821.5)"/><rect x="155" y="837" width="31" height="31" transform="rotate(0,170.5,852.5)"/><rect x="155" y="868" width="31" height="31" transform="rotate(0,170.5,883.5)"/><rect x="186" y="806" width="31" height="31" transform="rotate(0,201.5,821.5)"/><rect x="186" y="837" width="31" height="31" transform="rotate(0,201.5,852.5)"/><rect x="186" y="868" width="31" height="31" transform="rotate(0,201.5,883.5)"/></clipPath></defs><rect x="0" y="0" height="1024" width="1024" clip-path="url('#clip-path-background-color')" fill="#ffffff"/><rect x="62" y="62" height="899" width="899" clip-path="url('#clip-path-dot-color')" fill="#000000"/><rect x="62" y="62" height="217" width="217" clip-path="url('#clip-path-corners-square-color-0-0')" fill="#000000"/><rect x="124" y="124" height="93" width="93" clip-path="url('#clip-path-corners-dot-color-0-0')" fill="#000000"/><rect x="744" y="62" height="217" width="217" clip-path="url('#clip-path-corners-square-color-1-0')" fill="#000000"/><rect x="806" y="124" height="93" width="93" clip-path="url('#clip-path-corners-dot-color-1-0')" fill="#000000"/><rect x="62" y="744" height="217" width="217" clip-path="url('#clip-path-corners-square-color-0-1')" fill="#000000"/><rect x="124" y="806" height="93" width="93" clip-path="url('#clip-path-corners-dot-color-0-1')" fill="#000000"/></svg>
        </div>
      </div>
    </div><!--End Invoice-->
  </div>
</template>
<script>
import { onMounted, ref } from '@vue/composition-api'
import axios from 'axios'
import { Printd } from 'printd'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useCustomerSubscriptions from './useCustomerSubscriptions'

export default {
  props: {},
  setup(props, context) {
    const toast = useToast()
    const subscriptionId = context.root.$route.params.id
    const { customerId } = context.root.$route.params
    const subscription = ref({})
    const fullAddress = ref('')
    const footer = ref('')
    const user = ref('')
    const {
      fetchCustomerSubscription,
    } = useCustomerSubscriptions()

    const handlePrint = () => {
      const cssText = `@media print {
          .page-break {
              display: block;
              page-break-before: always;
          }
      }

      /* arabic */
      @font-face {
        font-family: 'El Messiri';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/elmessiri/v22/K2F0fZBRmr9vQ1pHEey6MoiAAhLz.woff2) format('woff2');
        unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0898-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC;
      }
      /* cyrillic */
      @font-face {
        font-family: 'El Messiri';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/elmessiri/v22/K2F0fZBRmr9vQ1pHEey6MomAAhLz.woff2) format('woff2');
        unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
      }
      /* latin-ext */
      @font-face {
        font-family: 'El Messiri';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/elmessiri/v22/K2F0fZBRmr9vQ1pHEey6MoOAAhLz.woff2) format('woff2');
        unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
      }
      /* latin */
      @font-face {
        font-family: 'El Messiri';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/elmessiri/v22/K2F0fZBRmr9vQ1pHEey6Mo2AAg.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }
      /* arabic */
      @font-face {
        font-family: 'El Messiri';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/elmessiri/v22/K2F0fZBRmr9vQ1pHEey6MoiAAhLz.woff2) format('woff2');
        unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0898-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC;
      }
      /* cyrillic */
      @font-face {
        font-family: 'El Messiri';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/elmessiri/v22/K2F0fZBRmr9vQ1pHEey6MomAAhLz.woff2) format('woff2');
        unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
      }
      /* latin-ext */
      @font-face {
        font-family: 'El Messiri';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/elmessiri/v22/K2F0fZBRmr9vQ1pHEey6MoOAAhLz.woff2) format('woff2');
        unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
      }
      /* latin */
      @font-face {
        font-family: 'El Messiri';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/elmessiri/v22/K2F0fZBRmr9vQ1pHEey6Mo2AAg.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }
      /* arabic */
      @font-face {
        font-family: 'Tajawal';
        font-style: normal;
        font-weight: 200;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l_6gHrRpiYlJ.woff2) format('woff2');
        unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0898-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC;
      }
      /* latin */
      @font-face {
        font-family: 'Tajawal';
        font-style: normal;
        font-weight: 200;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l_6gHrFpiQ.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }
      /* arabic */
      @font-face {
        font-family: 'Tajawal';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/tajawal/v9/Iura6YBj_oCad4k1nzSBC45I.woff2) format('woff2');
        unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0898-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC;
      }
      /* latin */
      @font-face {
        font-family: 'Tajawal';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/tajawal/v9/Iura6YBj_oCad4k1nzGBCw.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }
      /* arabic */
      @font-face {
        font-family: 'Tajawal';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l4qkHrRpiYlJ.woff2) format('woff2');
        unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0898-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC;
      }
      /* latin */
      @font-face {
        font-family: 'Tajawal';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l4qkHrFpiQ.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }
      /* arabic */
      @font-face {
        font-family: 'Tajawal';
        font-style: normal;
        font-weight: 900;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l7KmHrRpiYlJ.woff2) format('woff2');
        unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0898-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC;
      }
      /* latin */
      @font-face {
        font-family: 'Tajawal';
        font-style: normal;
        font-weight: 900;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/tajawal/v9/Iurf6YBj_oCad4k1l7KmHrFpiQ.woff2) format('woff2');
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }

      #subscription-invoice-POS {
          padding: 0 10mm 2mm 0;
          margin: 0 auto;
          width: 100mm;
          background: #FFF;
          font-family: 'arial', serif !important;
      }

      #subscription-invoice-POS .font-size {
        font-size: 16px !important;
      }

      #subscription-invoice-POS .info-container {
        display: flex;
        justify-content: start;
        word-break: break-word;
      }

      #subscription-invoice-POS .info-container span:not(:last-child) {
        border-right: 1px solid #000;
        margin-right: 5px;
        padding-right: 5px;
      }

      #subscription-invoice-POS ::selection {
          background: #f31544;
          color: #FFF;
      }

      #subscription-invoice-POS ::moz-selection {
          background: #f31544;
          color: #FFF;
      }

      #subscription-invoice-POS h1 {
          font-size: 1.5em;
          color: #000;
          margin-bottom: 0px !important;
          margin-top: 0px !important;
      }

      #subscription-invoice-POS h2 {
          font-size: 10px;
          margin-bottom: 0px !important;
          margin-top: 0px !important;
      }

      #subscription-invoice-POS h3 {
          font-size: 1.2em;
          font-weight: 300;
          line-height: 2em;
          margin-bottom: 0px !important;
          margin-top: 0px !important;
      }

      #subscription-invoice-POS h5 {
          margin-bottom: 0px !important;
          margin-top: 0px !important;
      }

      #subscription-invoice-POS p {
          font-size: 10px;
          font-weight: bold;
          color: #000;
          line-height: 1.2em;
          margin-bottom: 0 !important;
      }

      #subscription-invoice-POS .no-spaces {
          margin-bottom: 0 !important;
          margin-top: 0 !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;
      }

      #subscription-invoice-POS #top, #subscription-invoice-POS #mid, #subscription-invoice-POS #mid-1, #subscription-invoice-POS #mid-2, #subscription-invoice-POS #bot, #subscription-invoice-POS .table-header {
        border-bottom: 1px dashed #000;
        padding-bottom: 20px !important;
      }

      #subscription-invoice-POS #bot {
        padding-top: 0px !important;
        padding-bottom: 3px !important;
      }

      #subscription-invoice-POS .balance-row { /* , #subscription-invoice-POS .table-header */
        border-top: 1px dashed #000;
      }

      #subscription-invoice-POS #top {
          min-height: 80px;
      }

      #subscription-invoice-POS #mid {
          min-height: 50px;
      }


      #subscription-invoice-POS #bot {
          min-height: 50px;
      }

      #subscription-invoice-POS #bot h2 {
          font-size: 10px;
      }

      #subscription-invoice-POS #top .logo {
          height: 80px;
          width: 80px;
      }

      #subscription-invoice-POS .clientlogo {
          float: left;
          height: 60px;
          width: 60px;
          background: url(http://michaeltruong.ca/images/client.jpg) no-repeat;
          background-size: 60px 60px;
          border-radius: 50px;
      }

      #subscription-invoice-POS .info {
          display: block;
          margin-left: 0;
      }

      #subscription-invoice-POS .title {
          float: right;
      }

      #subscription-invoice-POS .title p {
          text-align: right;
      }

      #subscription-invoice-POS table {
          width: 100%;
          border-collapse: collapse;
      }

      #subscription-invoice-POS .tabletitle {
          font-size: 10px;
          font-weight: bold;
          margin: 3px;
          background: #EEE;
      }

      #subscription-invoice-POS .service {
          border-bottom: 1px solid #000;
      }

      #subscription-invoice-POS .item {
          // width: 24mm;
      }

      #subscription-invoice-POS .tableitem {
          line-height: 1;
          padding-bottom: 5px;
      }

      #subscription-invoice-POS .itemtext {
          font-size: 10px;
          font-weight: bold;
          line-height: 1.6;
      }

      #subscription-invoice-POS .noteitem {
          line-height: 1.45;
      }

      #subscription-invoice-POS .notetext {
          margin-inline: .5rem;
      }

      #subscription-invoice-POS .payment {
          padding: 0 5px;
      }

      #subscription-invoice-POS #legalcopy {
          margin-top: 5mm;
          margin-right: 1em;
          margin-left: 1em;
          text-align: center;
      }

      #subscription-invoice-POS .phone-box {
        flex-shrink: 0;
      }`

      const d = new Printd()
      setTimeout(() => {
        d.print(document.getElementById('subscription-invoice-POS'), [cssText])
      }, 50)
    }

    onMounted(() => {
      fetchCustomerSubscription(subscriptionId, customerId).then(res => {
        subscription.value = res

        axios.get(`${process.env.VUE_APP_BASE_API_URL}/pos/users/${res.user.id}`, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        }).then(userRes => {
          if (userRes.data.code === 200) {
            user.value = userRes.data.data.user

            const address = userRes.data.data.user.primary_address
            if (address) {
              const { area } = address
              // const city = area.city ?? null
              // if (city) fullAddress.value += ` City: ${city.name}, `
              if (area) fullAddress.value += ` Area: ${area.name?.en}, `
              if (address.block) fullAddress.value += ` Block: ${address.block}, `
              if (address.avenue) fullAddress.value += ` Avenue: ${address.avenue}, `
              if (address.street) fullAddress.value += ` Street: ${address.street}, `
              if (address.building) fullAddress.value += ` Building: ${address.building}, `
              if (address.floor_number) fullAddress.value += ` Floor_number: ${address.floor_number}, `
              if (address.apartment_number) fullAddress.value += ` Apartment Number: ${address.apartment_number}, `
              if (address.landmark) fullAddress.value += ` Landmark: ${address.landmark}, `
              if (address.details) fullAddress.value += ` Details: ${address.details}, `
            }

            handlePrint()
          }
        }).catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching user',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
      })
    })

    return {
      customerId,
      subscription,
      user,
      fullAddress,
      footer,
      handlePrint,
    }
  },
}
</script>
<style scoped>
@media print {
  .page-break {
    display: block;
    page-break-before: always;
  }
}

#subscription-invoice-POS {
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  padding: 0 2mm;
  margin: 0 auto;
  width: 77mm;
  background: #FFF;
  font-family: 'arial', serif !important;
}

#subscription-invoice-POS ::selection {
  background: #f31544;
  color: #FFF;
}

#subscription-invoice-POS ::moz-selection {
  background: #f31544;
  color: #FFF;
}

#subscription-invoice-POS h1 {
  font-size: 1.5em;
  color: #222;
}

#subscription-invoice-POS h2 {
  font-size: 10px;
}

#subscription-invoice-POS h3 {
  font-size: 1.2em;
  font-weight: 300;
  line-height: 2em;
}

#subscription-invoice-POS p {
  font-size: 10px;
  font-weight: bold;
  color: #666;
  line-height: 1.2em;
}

#subscription-invoice-POS #top, #subscription-invoice-POS #mid, #subscription-invoice-POS #mid-1, #subscription-invoice-POS #mid-2, #subscription-invoice-POS #bot, #subscription-invoice-POS .table-header {
  border-bottom: 1px dashed #000;
  /*padding-top: 10px;*/
}

#subscription-invoice-POS #bot {
  padding-top: 0px !important;
}

#subscription-invoice-POS .balance-row { /* , #subscription-invoice-POS .table-header */
  border-top: 1px dashed #000;
}

#subscription-invoice-POS #top {
  min-height: 80px;
}

#subscription-invoice-POS #mid {
  min-height: 50px;
}

/*#subscription-invoice-POS #mid-1 {*/
/*  min-height: 30px;*/
/*}*/

#subscription-invoice-POS #bot {
  min-height: 50px;
}

#subscription-invoice-POS #bot h2 {
  font-size: 10px;
}

#subscription-invoice-POS #top .logo {
  height: 80px;
  width: 80px;
}

#subscription-invoice-POS .clientlogo {
  float: left;
  height: 60px;
  width: 60px;
  background: url(http://michaeltruong.ca/images/client.jpg) no-repeat;
  background-size: 60px 60px;
  border-radius: 50px;
}

#subscription-invoice-POS .info {
  display: block;
  margin-left: 0;
}

#subscription-invoice-POS .info-container {
  display: flex;
  justify-content: start;
  word-break: break-word;
}

#subscription-invoice-POS .info-container span:not(:last-child) {
  border-right: 1px solid #000;
  margin-right: 5px;
  padding-right: 5px;
}

#subscription-invoice-POS h1 {
  font-size: 1.5em;
  color: #000;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}

#subscription-invoice-POS h2 {
  font-size: 10px;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}

#subscription-invoice-POS h3 {
  font-size: 1.2em;
  font-weight: 300;
  line-height: 2em;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}

#subscription-invoice-POS h5 {
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}

#subscription-invoice-POS .title {
  float: right;
}

#subscription-invoice-POS .title p {
  text-align: right;
}

#subscription-invoice-POS table {
  width: 100%;
  border-collapse: collapse;
}

#subscription-invoice-POS .tabletitle {
  font-size: 10px;
  font-weight: bold;
  margin: 3px;
  background: #EEE;
}

#subscription-invoice-POS .service {
  border-bottom: 1px solid #000;
  /*padding-top: 10px !important;*/
  /*padding-bottom: 10px !important;*/
}

#subscription-invoice-POS #mid-2 {
  /*padding-top: 10px !important;*/
}

#subscription-invoice-POS .item {
  /*width: 24mm;*/
}

#subscription-invoice-POS .tableitem {
  line-height: 0.8;
  padding-bottom: 5px;
}

#subscription-invoice-POS .itemtext {
  font-size: 10px;
  font-weight: bold;
  line-height: 1.6;
}

#subscription-invoice-POS .noteitem {
  line-height: 1.45;
}

#subscription-invoice-POS .notetext {
  margin-inline: .5rem;
}

#subscription-invoice-POS #legalcopy {
  font-size: 0.5em;
  margin-top: 5mm;
  color: #666;
}

#subscription-invoice-POS h2 {
  color: #666;
}

#subscription-invoice-POS span {
  color: #666;
}

#subscription-invoice-POS .font-size {
  font-size: 11px !important;
}

#subscription-invoice-POS .phone-box {
  flex-shrink: 0;
}
</style>
